module.exports = __webpack_public_path__ + "img/zhiyao1.e1a733a7.png";